export default __webpack_public_path__ + "static/media/CapaDeleteBlue.45dc1249.svg";